import { ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FoodaholixService } from 'app/core/services';
import { Download } from 'app/core/services/download';
import { Observable } from 'rxjs';

export interface MultiImageViewerData {
  images: string[];
  currentIndex?: number;
  title?: string;
  downloadImage?: boolean;
}

@Component({
  selector: 'app-multi-image-viewer',
  templateUrl: './multi-image-viewer.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class MultiImageViewerComponent implements OnInit {
  images: string[];
  currentIndex: number = 0;
  title: string;
  downloadImage = false;
  downloadProgress$: Observable<Download>;

  constructor(
    public dialogRef: MatDialogRef<MultiImageViewerComponent>,
    @Inject(MAT_DIALOG_DATA) data: MultiImageViewerData,
    private _foodaholixService: FoodaholixService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {
    this.images = data.images || [];
    this.currentIndex = data.currentIndex || 0;
    this.title = data.title || '';
    this.downloadImage = data.downloadImage || false;
  }

  ngOnInit() {
    this.downloadProgress$ = this._foodaholixService.downloadProgress$;
    this._changeDetectorRef.detectChanges();
  }

  get currentImage(): string {
    return this.images[this.currentIndex];
  }

  get hasPrevious(): boolean {
    return this.currentIndex > 0;
  }

  get hasNext(): boolean {
    return this.currentIndex < this.images.length - 1;
  }

  previous() {
    if (this.hasPrevious) {
      this.currentIndex--;
      this._changeDetectorRef.markForCheck();
    }
  }

  next() {
    if (this.hasNext) {
      this.currentIndex++;
      this._changeDetectorRef.markForCheck();
    }
  }

  goToImage(index: number) {
    if (index >= 0 && index < this.images.length) {
      this.currentIndex = index;
      this._changeDetectorRef.markForCheck();
    }
  }
}
